<div class="py-12 sm:py-16">
    <div class="mx-auto max-w-5xl px-5 grid grid-cols-1" [ngClass]="{'lg:grid-cols-5 lg:gap-6': !fullWidth}">
        <div class="lg:col-span-2 flex flex-col" *ngIf="!fullWidth">
            <div>
                <h2 class="text-3xl font-bold tracking-tight sm:text-4xl mt-4">
                    <span class="text-turquoise">Your</span> Dimers Platinum <span class="text-turquoise">questions answered</span> 
                </h2>
                <p class="mt-6 text-base leading-7">
                    Everything you need to know is right here—straight answers, no BS.
                </p>
            </div>
        </div>

        <div class="mt-4 lg:mt-0 " [ngClass]="{'lg:col-span-3': !fullWidth}">
            <dl>
                <div *ngFor="let faq of faqs; let i = index" class="border-b border-gray-200">
                    <dt>
                        <button (click)="toggleFaq(i)" type="button"
                            class="flex w-full items-center justify-between py-6 text-left"
                            [attr.aria-controls]="'faq-answer-' + i" [attr.aria-expanded]="openFaqIndex === i">
                            <span class="text-base font-medium">{{ faq.question }}</span>
                            <span class="ml-6 flex h-7 items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor"
                                    class="h-6 w-6 transform transition-transform duration-300"
                                    [class.rotate-180]="openFaqIndex !== i">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                                </svg>
                            </span>
                        </button>
                    </dt>

                    <dd class="pr-12" id="faq-answer-{{ i }}" *ngIf="openFaqIndex === i">
                        <p class="pb-6 text-base">{{ faq.answer }}</p>
                    </dd>
                </div>
            </dl>
        </div>
    </div>
</div>